var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticClass:"grey lighten-4 my-4",attrs:{"aspect-ratio":_vm.asset.aspectRatio,"eager":true,"src":_vm.asset.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }